export const ReceiptsManagementHandler = {
  selectAllReceipts(context) {
    context.$store.commit('SELECT_ALL_RECEIPTS');
  },

  removeAllReceipts(context) {
    context.$store.commit('REMOVE_ALL_RECEIPTS');
  },

  getSelectedReceipt(context, receiptId) {
    return context.$store.getters.selectedReceipts[receiptId];
  },

  getPrintMode(context) {
    return context.$store.getters.printMode;
  },

  setPrintMode(context, printMode) {
    return context.$store.commit('SET_PRINT_MODE', printMode);
  },

  getSelectedReceipts(context) {
    return context.$store.getters.selectedReceipts;
  },

  setSelectedReceipts(context, receipt) {
    context.$store.commit('SET_SELECTED_RECEIPTS', receipt);
  },

  setAllSelectedReceipts(context, selectedReceipts) {
    context.$store.commit('SET_ALL_SELECTED_RECEIPTS', selectedReceipts);
  }
};

const state = {
  selectedReceipts: {},
  printMode: false
};

const getters = {
  selectedReceipts: (state) => {
    return state.selectedReceipts;
  },
  printMode: (state) => {
    return state.printMode;
  }
};

const mutations = {
  SET_SELECTED_RECEIPTS: (state, receipt) => {
    state.selectedReceipts[receipt] = !state.selectedReceipts[receipt];
  },

  SET_PRINT_MODE: (state, printMode) => {
    state.printMode = printMode;
  },

  SET_ALL_SELECTED_RECEIPTS: (state, selectedReceipts) => {
    state.selectedReceipts = selectedReceipts;
  },

  SELECT_ALL_RECEIPTS: (state) => {
    Object.keys(state.selectedReceipts).forEach((receipt) => {
      state.selectedReceipts[receipt] = true;
    });
  },

  REMOVE_ALL_RECEIPTS: (state) => {
    Object.keys(state.selectedReceipts).forEach((receipt) => {
      state.selectedReceipts[receipt] = false;
    });
  }
};

export default {
  state,
  getters,
  mutations
};
